var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsunto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 1366 768",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321 668.55c9.874-35.088 19.748-70.162 29.622-105.221 7.185-25.434 14.018-50.957 21.644-76.215a39.188 39.188 0 019.433-15.957 255565.11 255565.11 0 01333.47-334.088 79.97 79.97 0 0139.673-22.04h16.619c10.667 3.879 21.599 7.229 31.914 11.901a50.987 50.987 0 0113.974 10.712c20.938 20.674 41.7 41.568 62.418 62.418 29.578 29.755 29.71 71.72 0 101.386A155397.685 155397.685 0 01546.12 635.489a39.18 39.18 0 01-16.001 9.345c-58.143 16.795-116.55 33.105-174.692 49.503-16.795 4.717-27.594-1.366-34.427-18.69v-7.097zm206.65-95.082l234.642-233.892-89.572-89.572-234.642 233.627c30.24 30.416 60.479 60.567 89.572 89.837zm274.799-266.336c11.373-11.372 23.099-23.01 34.736-34.779 10.05-10.227 10.006-21.247 0-31.518-11.902-12.034-23.892-23.98-35.882-35.97-8.816-8.816-17.368-17.632-26.448-26.228-7.714-7.45-19.131-8.816-26.449-2.028-13.224 12.563-25.434 26.096-37.909 39.056l91.952 91.467zM388.576 628.921l94.112-26.448-67.664-67.884-26.448 94.332z",
    fill: "#B4B4B4"
  })));
}

export default SvgAsunto;